export const ACCEPTANCE_OF_TERMS_HREF = '#acceptance-of-terms';
export const PRIVACY_HREF = '#privacy';
